import Vue from 'vue';
import { gsap, Quint, Power3 } from 'gsap';
import { SplitText } from '../gsap-bonus/SplitText';
import VimeoInlineComponent from './vimeo-inline-component.vue';

Vue.component('projects-filter-component', {
    props: {
        projects: {
            type: Array,
        },
    },

    components: {
        VimeoInlineComponent,
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            open: false,
            filter: 'all',
        };
    },

    computed: {
        filteredProjects() {
            const projects = this.projects.filter((project) => project.projectcategories.some((cat) => this.filter === cat.toLowerCase()));

            return projects;
        },
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {

    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        toggleFilter(event) {
            const item = document.getElementsByClassName('project-filter__current')[0];
            const itemContainer = item.nextElementSibling;

            if (item.classList.contains('open-filter')) {
                item.classList.remove('open-filter');
                gsap.to(itemContainer, {
                    duration: 1,
                    height: 0,
                    ease: Quint.easeOut,
                });
            } else {
                item.classList.add('open-filter');
                gsap.to(itemContainer, {
                    duration: 1,
                    height: 'auto',
                    ease: Quint.easeOut,
                });
            }
        },

        setFilter(event) {
            const title = event.currentTarget.getAttribute('data-option-title');
            const slug = event.currentTarget.getAttribute('data-option-slug');
            const current = document.getElementsByClassName('project-filter__current-text')[0];
            const container = document.getElementById('projects-container');
            Array.from(document.querySelectorAll('.project-filter__option')).forEach((el) => el.classList.remove('active'));
            event.currentTarget.classList.add('active');
            current.innerHTML = title;
            this.toggleFilter();

            gsap.to(container, {
                autoAlpha: 0,
                ease: Quint.easeOut,
                onComplete: () => {
                    this.changeFilter(title.toLowerCase());
                },
            });
            gsap.to(container, { autoAlpha: 1, ease: Quint.easeOut, delay: 1 });
        },

        changeFilter(filter) {
            this.filter = filter;
        },
    },
});
